import React from 'react';
import { toAbsoluteUrl } from 'newApp/helpers/assets';

const DEFAULT_SPRITE_PATH = '/icons.svg';

export interface SVGSpriteIconProps {
  className?: string;
  icon: string;
  spritePath?: string;
  style?: React.CSSProperties;
  title?: string;
  width?: string | number;
  height?: string | number;
}

const SVGSpriteIcon = ({
  className = '',
  icon,
  spritePath = DEFAULT_SPRITE_PATH,
  style,
  title,
  width,
  height,
}: SVGSpriteIconProps) => {
  const href = icon.startsWith('#')
    ? `${toAbsoluteUrl(spritePath)}${icon}`
    : icon.includes('#')
      ? toAbsoluteUrl(icon)
      : `${toAbsoluteUrl(spritePath)}#${icon}`;
  const isDecorative = !title;

  return (
    <svg
      className={className}
      aria-hidden={isDecorative}
      aria-label={title}
      role={isDecorative ? undefined : 'img'}
      focusable="false"
      style={style}
    >
      {title ? <title>{title}</title> : null}
      <use href={href} width={width} height={height} />
    </svg>
  );
};

export default SVGSpriteIcon;
